import { Text } from '@savvy-kit/foundations/text';
import { ArrowUpRight } from 'lucide-react';

const frequentlyAskedQuestions = [
  {
    question: 'How can client marketing help market my practice?',
    url: 'https://docs.google.com/presentation/d/1lpH8aQNjehHAYpZlUMBHGkq6PAxQa99DY5ZMeSs0sOs/edit?slide=id.p#slide=id.p',
  },
  {
    question: "Where can I learn about Savvy's Growth Program?",
    url: 'https://savvy-growth-program.int.savvy.sh',
  },
  {
    question: "Who are Savvy's approved vendors?",
    url: 'https://docs.google.com/spreadsheets/d/1PbF29I_aaYYGCxsdQ9w-ulJCPR4gvtTRpcjNIiJlUgU/edit?gid=1399741991#gid=1399741991',
  },
  {
    question: 'Does Savvy have a branded template I can use for presentations?',
    url: 'https://docs.google.com/presentation/d/1KupKuFxwSalYILFt5FDu4p4uH6PARDx0fVvsp1GdEJI/edit?slide=id.g344e33531cd_0_931#slide=id.g344e33531cd_0_931',
  },
  {
    question: 'How can I access Savvy’s email marketing platform (Constant Contact)?',
    url: 'https://savvy-email-marketing-hub.vercel.app/',
  },
];

function MarketingResourceList() {
  return (
    <div className="rounded-md border border-light overflow-hidden">
      <div className="bg-stone-50 dark:bg-card px-4 py-3">
        <h4 className="text-sm font-semibold">FAQ</h4>
        <Text variant="caption" render={<p />}>
          Answers to the most common questions
        </Text>
      </div>
      <div className="divide-y divide-border-light">
        {frequentlyAskedQuestions.map((faq) => (
          <a
            key={faq.question}
            href={faq.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-component-hover transition-colors group"
          >
            <span className="text-sm font-medium">{faq.question}</span>
            <ArrowUpRight className="size-3.5 shrink-0 text-secondary group-hover:text-primary transition-colors" />
          </a>
        ))}
      </div>
    </div>
  );
}

export default MarketingResourceList;
